
import { defineComponent } from "vue"
import { TranslationKey } from "@/i18n/translationKeys";
import { store } from "@/store";

export default defineComponent({
  name: "NotFound",

  data() {
    return {
      offerNotFound: this.$t(TranslationKey.OfferNotFound)
    }
  },

  computed: {
    Language() {
      return store.getters.GetCurrentLanguage
    }
  },

  watch: {
    Language() {
      this.offerNotFound = this.$t(TranslationKey.OfferNotFound)
    }
  },
})
